import { useEffect, useState } from 'react';

const DelayRender = ({ children, delay = 300, ...props }) => {

    const [firstRun, setFirstRun] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => setFirstRun(false), delay);
        return () => clearTimeout(timeout);
    }, []);

    return firstRun ? null : children;
}

export default DelayRender;